module.exports = __webpack_public_path__ + "img/61.62b685ae.jpg";